import getPermittedAdminRoutes from './getPermittedAdminRoutes';
import ROUTE_NAMES from '../../../../vue/routes/routeNames';

export default (
    excludeRouteName?: string,
    forbiddenRoutes: Set<string> = new Set(),
): string => {
    const routes = getPermittedAdminRoutes()
        .filter((route) =>
            (!excludeRouteName || route.name !== excludeRouteName) &&
            !forbiddenRoutes.has(route.name),
        );

    return routes.length
        ? routes[0].name
        : ROUTE_NAMES.NO_ACCESS;
};
